import { language } from '@tencent/ppd-base-libs';
import { isGrayUser } from '@tencent/wphk-components-gray-release';
import { to } from '@tencent/wphk-base-utils';

const IS_FIRST_VISIT = 'discount_center_is_first';
/**
 * 获取多语言属性
 */
export function getMultiLangAttr(data) {
  if (typeof data !== 'object') return;
  const lang = language.getLanguage();
  if (lang === 'en' && data.en) {
    return data.en;
  }
  if (lang === 'zh-cn' && data.cn) {
    return data.cn;
  }
  return data.hk;
}

/**
 * 获取语言后缀
 */
export function getLangSuffix() {
  const lang = language.getLanguage();
  if (lang === 'en') {
    return 'En';
  }
  if (lang === 'zh-cn') {
    return 'Cn';
  }
  return '';
}

/**
 * 是否命中灰度
 */
export async function isGray() {
  // 布尔值，是否命中灰度逻辑
  const [err, isGray] = await to(isGrayUser({
    business: 'discount-center',
    name: 'home',
  }));
  if (err) {
    return false;
  }
  return isGray;
}

/**
 * 是否首次访问wecoupons
 */
export function isFirstVisitWecoupons() {
  return sessionStorage.getItem(IS_FIRST_VISIT) !== '1';
}

/**
 * 记录已经访问过wecoupons了
 */
export function saveFirstVisitWecoupons() {
  return sessionStorage.setItem(IS_FIRST_VISIT, '1');
}

